
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/waianapanapa",
      function () {
        return require("private-next-pages/waianapanapa/index.js");
      }
    ]);
  